import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createPolicyRequest = { policy: '_policy' };
var _createPolicyResponse = { policy: '_policy' };
var _deletePolicyRequest = {};
var _deletePolicyResponse = {};
var _getPolicyRequest = {};
var _getPolicyResponse = { policy: '_policy' };
var _policy = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _queryPoliciesRequest = {};
var _queryPoliciesResponse = { policies: '_policy' };
var _reorderEventPoliciesRequest = {};
var _reorderEventPoliciesResponse = { policies: '_policy' };
var _updatePolicyRequest = {
    mask: 'google.protobuf.FieldMask',
    policy: '_policy',
};
var _updatePolicyResponse = { policy: '_policy' };
function resolveWixEventsV2PolicyManagementUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/events-policies',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/events-policies',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-policies',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events-policies',
                destPath: '',
            },
            {
                srcPath: '/events/v2/policies',
                destPath: '/v2/policies',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/events-policies',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/events-policies',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/events-policies',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/events-policies',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a policy.
 * You can create up to 3 policies per event. If you try to create more than 3, you'll get the "Maximum number of policies for the event has been reached" error.
 */
export function createPolicy(payload) {
    var _a = serializer(_createPolicyRequest, { _policy: _policy }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPolicyResponse, { _policy: _policy }).fromJSON;
    function __createPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.policy',
            method: 'POST',
            methodFqn: 'wix.events.v2.PolicyManagement.CreatePolicy',
            url: resolveWixEventsV2PolicyManagementUrl({
                protoPath: '/v2/policies',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPolicy.fromReq = fromReq;
    __createPolicy.__isAmbassador = true;
    return __createPolicy;
}
/**
 * Updates a policy.
 * Each time the policy is updated, `revision` increments by 1. The existing `revision` must be included when updating the policy. This ensures you're working with the latest policy and prevents unintended overwrites.
 */
export function updatePolicy(payload) {
    var _a = serializer(_updatePolicyRequest, { _policy: _policy }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePolicyResponse, { _policy: _policy }).fromJSON;
    function __updatePolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.policy',
            method: 'PATCH',
            methodFqn: 'wix.events.v2.PolicyManagement.UpdatePolicy',
            url: resolveWixEventsV2PolicyManagementUrl({
                protoPath: '/v2/policies/{policy.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePolicy.fromReq = fromReq;
    __updatePolicy.__isAmbassador = true;
    return __updatePolicy;
}
/** Permanently deletes a policy. */
export function deletePolicy(payload) {
    var _a = serializer(_deletePolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deletePolicyResponse, {}).fromJSON;
    function __deletePolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.policy',
            method: 'DELETE',
            methodFqn: 'wix.events.v2.PolicyManagement.DeletePolicy',
            url: resolveWixEventsV2PolicyManagementUrl({
                protoPath: '/v2/policies/{policyId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deletePolicy.fromReq = fromReq;
    __deletePolicy.__isAmbassador = true;
    return __deletePolicy;
}
/** Retrieves a list of policies according to the provided filters and paging. */
export function queryPolicies(payload) {
    var _a = serializer(_queryPoliciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPoliciesResponse, { _policy: _policy }).fromJSON;
    function __queryPolicies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.policy',
            method: 'POST',
            methodFqn: 'wix.events.v2.PolicyManagement.QueryPolicies',
            url: resolveWixEventsV2PolicyManagementUrl({
                protoPath: '/v2/policies/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPolicies.fromReq = fromReq;
    __queryPolicies.__isAmbassador = true;
    return __queryPolicies;
}
/**
 * Changes policy order in an event dashboard and agreement checkbox on the checkout form. By default, the policies are arranged by the created date in descending order.
 * > **Note:** It is possible to use both `beforePolicyId` and `afterPolicyId` at the same time but only the last one defined will be executed.
 */
export function reorderEventPolicies(payload) {
    var _a = serializer(_reorderEventPoliciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reorderEventPoliciesResponse, {
        _policy: _policy,
    }).fromJSON;
    function __reorderEventPolicies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.policy',
            method: 'POST',
            methodFqn: 'wix.events.v2.PolicyManagement.ReorderEventPolicies',
            url: resolveWixEventsV2PolicyManagementUrl({
                protoPath: '/v2/policies/reorder',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reorderEventPolicies.fromReq = fromReq;
    __reorderEventPolicies.__isAmbassador = true;
    return __reorderEventPolicies;
}
/** Retrieves a policy. */
export function getPolicy(payload) {
    var _a = serializer(_getPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPolicyResponse, { _policy: _policy }).fromJSON;
    function __getPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.policy',
            method: 'GET',
            methodFqn: 'wix.events.v2.PolicyManagement.GetPolicy',
            url: resolveWixEventsV2PolicyManagementUrl({
                protoPath: '/v2/policies/{policyId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPolicy.fromReq = fromReq;
    __getPolicy.__isAmbassador = true;
    return __getPolicy;
}
//# sourceMappingURL=http.impl.js.map